import React, { useEffect, useState } from 'react';

declare global {
  interface Window {
    myChatWidget?: {
      load: (config: { assistantId: string; apiKey: string }) => void;
    };
  }
}

const EntraCleanChatBot: React.FC = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const loadChatWidget = () => {
      const v = document.createElement('script');
      v.type = "text/javascript";
      v.src = "https://agentivehub.com/production.bundle.min.js";
      v.async = true;
      v.onload = () => {
        if (!document.getElementById('root')) {
          const root = document.createElement('div');
          root.id = 'root';
          document.body.appendChild(root);
        }
        if (window.myChatWidget && typeof window.myChatWidget.load === 'function') {
          try {
            window.myChatWidget.load({
              assistantId: '0bbc691f-221b-4c25-a11a-0d4ec5862daa',
              apiKey: '5e9fc760-d861-45eb-8095-72159f99cdf4',
            });
            setIsLoading(false);
          } catch (err) {
            setError('Failed to initialize chat widget');
            setIsLoading(false);
          }
        } else {
          setError('Chat widget not available');
          setIsLoading(false);
        }
      };
      v.onerror = () => {
        setError('Failed to load chat widget script');
        setIsLoading(false);
      };
      const s = document.getElementsByTagName('script')[0];
      s.parentNode?.insertBefore(v, s);
    };

    loadChatWidget();

    return () => {
      // Cleanup function if needed
    };
  }, []);

  if (isLoading) {
    return <div className="chatbot-loading">Loading EntraClean chat bot...</div>;
  }

  if (error) {
    return <div className="chatbot-error">{error}</div>;
  }

  return (
    <div>
      <h1>EntraClean ChatBot</h1>
      <div id="chatbot-container" className="fullscreen" />
    </div>
  );
};

export default EntraCleanChatBot;